import React from 'react';
import './AboutUs.css'; // Reuse the global styles
import logo from '../assets/logo.png';
import MainMenu from '../components/MainMenu';
import heroImg from '../assets/about/hero-2.jpg';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

const Laboratory = () => {
  return (
    <div className="about-page">
      

    <div className="top-bar-wrapper">
  {/* Left: Ticker */}
  <div className="news-ticker">
    <div className="ticker-content">
      🎓 Admissions Open for 2025–2026 — Enroll Now at Universal Academy! 📢
    </div>
  </div>

  {/* Right: Location + Timing */}
   <div className="top-bar-info">
    <div className="top-item">
      <i className="fas fa-envelope"></i> universalacademy@gmail.com
    </div>
    <div className="top-item">
      <i className="fas fa-phone-alt"></i> 04368-221616
    </div>
    <div className="top-item">
      <i className="fas fa-map-marker-alt"></i> Neravy, Karaikal
    </div>
  
  </div>
</div>

	  
	<header className="logo-header">
  <div className="header-row">
    {/* Left: Logo */}
  <Link to="/" className="logo-area">
  <img src={logo} alt="Universal Academy Logo" />
</Link>
	
	{/* Title below logo+info */}
  <div className="school-title">
    <h1>UNIVERSAL ACADEMY</h1>
    <p>Affiliated to CBSE – Karaikal, Puducherry</p>
  </div>

    {/* Right: Contact Info */}
   
  </div>

  
</header>



<MainMenu />   
      {/* Hero Section */}
      <section className="about-hero">
	  <img src={heroImg} alt="Universal Academy Campus" />
        <div className="hero-text">
          <h1>Our Laboratories</h1>
          <p>Hands-on learning that shapes future scientists, engineers, and innovators.</p>
        </div>
      </section>

      {/* Lab Description Section */}
      <section className="about-intro">
        <h2>Where Science Meets Exploration</h2>
        <p>
          The importance of Science Labs in any Educational Institute is quite obvious. At Universal Academy, we have
          different laboratories for Physics, Chemistry, Mathematics, and Biology. It helps students learn to address
          the challenges inherent in directly observing and manipulating the material world. It not only develops understanding
          of measurement error and interpreting the resulting data but also nurtures hands-on skills and scientific curiosity.
        </p>
      </section>

      {/* Individual Labs */}
   <section className="about-leaders" style={{ paddingTop: '0px' }}>

  {/* Physics Lab */}
  <div className="leader-row">
    <div className="leader-image">
      <img src="/labs/1.png" alt="Physics Lab" />
    </div>
    <div className="leader-text">
      <h3>PHYSICS LAB</h3>
      <p>
        Equipped with apparatus for mechanics, optics, electronics and electromagnetism — our Physics Lab brings
        theoretical concepts to life and encourages scientific inquiry among students.
      </p>
    </div>
  </div>

  {/* Chemistry Lab */}
  <div className="leader-row reverse">
    <div className="leader-image">
      <img src="/labs/2.png" alt="Chemistry Lab" />
    </div>
    <div className="leader-text">
      <h3>CHEMISTRY LAB</h3>
      <p>
        A modern and safe environment where students learn chemical reactions, lab safety, and perform hands-on experiments
        with precision equipment and real-world examples.
      </p>
    </div>
  </div>

  {/* Biology Lab */}
  <div className="leader-row">
    <div className="leader-image">
      <img src="/labs/3.png" alt="Biology Lab" />
    </div>
    <div className="leader-text">
      <h3>BIOLOGY LAB</h3>
      <p>
        A space for exploration of life sciences. From microscopes to anatomy models, the lab provides essential
        experiences in cellular biology, botany, and zoology.
      </p>
    </div>
  </div>

  {/* Mathematics Lab */}
  <div className="leader-row reverse">
    <div className="leader-image">
      <img src="/labs/4.png" alt="Mathematics Lab" />
    </div>
    <div className="leader-text">
      <h3>MATHEMATICS LAB</h3>
      <p>
        As per CBSE guidelines and the National Education Policy, Universal Academy houses a dedicated Mathematics Lab.
        Students experience abstract concepts through tangible tools, puzzles, and models that foster innovation and logical thinking.
      </p>
    </div>
  </div>

  {/* Computer Lab */}
  <div className="leader-row">
    <div className="leader-image">
      <img src="/labs/5.png" alt="Computer Lab" />
    </div>
    <div className="leader-text">
      <h3>COMPUTER LAB</h3>
      <p>
        From Class I onwards, our students are introduced to the world of computers. Our lab is equipped with
        multimedia-enabled systems and internet access to empower learning across all domains with modern tools.
      </p>
    </div>
  </div>

</section>


    
	 <Footer />  
    </div>
  );
};

export default Laboratory;
